import useConfig from '@sdk/config/useConfig';
import useAuth from '@sdk/authentication/useAuth';
import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

const useIsTimesheetConsentFlowFeatureFlagEnabled = () => {
  const {
    FEATURE_FLAGS: { TIMESHEET_CONSENT_FLOW_ENABLED },
  } = useConfig();

  const { currentUser } = useAuth();

  return isFeatureEnabled(TIMESHEET_CONSENT_FLOW_ENABLED, currentUser.org.id);
};

export default useIsTimesheetConsentFlowFeatureFlagEnabled;
